<template>
  <a-spin :spinning="confirmLoading">
    <j-form-container :disabled="formDisabled">
      <!-- 主表单区域 -->
      <a-form :form="form" slot="detail">
        <a-row>
          <a-col :span="24" >
            <mtc-form-item label="label.company"  :labelCol="labelCol" :wrapperCol="wrapperCol">
              <j-dict-select-tag type="list" v-decorator="['companyCode',validatorRules.companyCode]" :trigger-change="true" dictCode="sys_depart,depart_name,org_code,org_category='1' and del_flag='0'"  :placeholder="$t('label.pleaseSelectCompany')"/>
            </mtc-form-item>
          </a-col>
          <a-col :span="24" >
            <mtc-form-item label="label.costItemCode" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input v-decorator="['costCode',validatorRules.costCode]" :placeholder="$t('label.pleaseEnterCostItemCode')" :trigger-change="true"></a-input>
            </mtc-form-item>
          </a-col>
          <a-col :span="24" >
            <mtc-form-item label="label.costItemName" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input v-decorator="['costName',validatorRules.costName]" :trigger-change="true" :placeholder="$t('label.pleaseEntercostItemName')"></a-input>
            </mtc-form-item>
          </a-col>
          <a-col :span="24" >
            <mtc-form-item label="label.type" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <j-dict-select-tag type="list" v-decorator="['types',validatorRules.types]" :trigger-change="true" dictCode="cost_calculation_type"  :placeholder="$t('label.pleaseSelectType')"/>
            </mtc-form-item>
          </a-col>
          <a-col :span="24">
            <mtc-form-item label="label.isProductionCost" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <j-dict-select-tag type="list" v-decorator="['validFlag',{'initialValue': 'Y'}]" :trigger-change="true" dictCode="sfyx" placeholder="请选择是否生产成本"/>
            </mtc-form-item>
          </a-col>

        </a-row>
      </a-form>
    </j-form-container>
    <!-- 子表单区域 -->
    <a-tabs v-model="activeKey" @change="handleChangeTabs">
      <a-tab-pane :tab="$t('label.details')" :key="refKeys[0]" :forceRender="true">
        <j-editable-table
          :ref="refKeys[0]"
          :loading="efsCapCostDetailTable.loading"
          :columns="efsCapCostDetailTable.columns"
          :dataSource="efsCapCostDetailTable.dataSource"
          :maxHeight="300"
          :disabled="formDisabled"
          :rowNumber="true"
          :rowSelection="true"
          :actionButton="true">
        </j-editable-table>
      </a-tab-pane>
    </a-tabs>
  </a-spin>
</template>

<script>

    import pick from 'lodash.pick'
    import { getGroupCode} from '@/api/api'
    import { getAction } from '@/api/manage'
    import { FormTypes,getRefPromise } from '@/utils/JEditableTableUtil'
    import { JEditableTableMixin } from '@/mixins/JEditableTableMixin'
    import { validateDuplicateValue } from '@/utils/util'
    import JFormContainer from '@/components/jeecg/JFormContainer'
    import JDictSelectTag from "@/components/dict/JDictSelectTag"

    export default {
        name: 'EfsCapCostForm',
        mixins: [JEditableTableMixin],
        components: {
            JFormContainer,
            JDictSelectTag,
        },
        data() {
            return {
                labelCol: {
                    xs: { span: 24 },
                    sm: { span: 6 },
                },
                wrapperCol: {
                    xs: { span: 24 },
                    sm: { span: 16 },
                },
                labelCol2: {
                    xs: { span: 24 },
                    sm: { span: 3 },
                },
                wrapperCol2: {
                    xs: { span: 24 },
                    sm: { span: 20 },
                },
                // 新增时子表默认添加几行空数据
                addDefaultRowNum: 1,
                validatorRules: {
                    companyCode: {
                        rules: [
                            { required: false},
                        ]
                    },
                    groupCode: {
                        rules: [
                            { required: false},
                        ]
                    },
                    costCode: {
                        rules: [
                            { required: true, message: '请输入成本项编号!'},
                        ]
                    },
                    costName: {
                        rules: [
                            { required: true, message: '请输入成本项名称!'},
                        ]
                    },
                    types: {
                        rules: [
                            { required: true, message: '请选择类型!'},
                        ]
                    },
                },
                refKeys: ['efsCapCostDetail', ],
                tableKeys:['efsCapCostDetail', ],
                activeKey: 'efsCapCostDetail',
                // efs_cap_cost_detail
                efsCapCostDetailTable: {
                    loading: false,
                    dataSource: [],
                    columns: [
                        {
                            //tableHeader.materialGroupCode
                            title: 'tableHeader.materialGroupCode',
                            // slotName: 'tableHeader.materialGroupCode',
                            // scopedSlots: { title: 'tableHeader.materialGroupCode'},
                            key: 'materialGroupCode',
                            type: FormTypes.select,
                            dictCode:"efs_md_mm_group,name,code",
                            width:"220px",
                            placeholder: this.$t('tip.pleaseInput') +'${title}',
                            defaultValue: '',
                            validateRules: [
                                {
                                    required: false, // 必填
                                    message: this.$t('tip.pleaseInput') + '${title}' // 提示的文本
                                }
                            ]
                        },
                        {
                            //tableHeader.materialGroup
                            // title: '物料组名称',
                            title: 'tableHeader.materialGroup',
                            key: 'materialGroupName',
                            type: FormTypes.input,
                            width:"220px",
                            placeholder: this.$t('tip.pleaseInput') +'${title}',
                            defaultValue: '',
                            validateRules: [
                                {
                                    required: false, // 必填
                                    message: this.$t('tip.pleaseInput') + '${title}' // 提示的文本
                                }
                            ]
                        },
                        {
                             //tableHeader.productCostAccountCode
                            // title: '生产成本科目代码',
                            title: 'tableHeader.productCostAccountCode',
                            key: 'subjectCode',
                            type: FormTypes.select,
                            dictCode:"efs_cap_subject_item,name,code",
                            width:"300px",
                            placeholder: this.$t('tip.pleaseInput') +'${title}',
                            defaultValue: '',
                            validateRules: [
                                {
                                    required: false, // 必填
                                    message: this.$t('tip.pleaseInput') + '${title}' // 提示的文本
                                }
                            ]
                        },
                        {
                             //tableHeader.productCostAccountName
                            // title: '生产成本科目名称',
                            title: 'tableHeader.productCostAccountName',
                            key: 'subjectName',
                            type: FormTypes.input,
                            width:"300px",
                            placeholder: this.$t('tip.pleaseInput') +'${title}',
                            defaultValue: '',
                            validateRules: [
                                {
                                    required: false, // 必填
                                    message: this.$t('tip.pleaseInput') + '${title}' // 提示的文本
                                }
                            ]
                        },
                        {
                             //tableHeader.inventoryAccountCode
                            // title: '库存科目代码',
                            title: 'tableHeader.inventoryAccountCode',
                            key: 'stockSubjectCode',
                            type: FormTypes.select,
                            dictCode:"efs_cap_subject_item,name,code",
                            width:"300px",
                            placeholder: this.$t('tip.pleaseInput') +'${title}',
                            defaultValue: '',
                            validateRules: [
                                {
                                    required: false, // 必填
                                    message: this.$t('tip.pleaseInput') + '${title}' // 提示的文本
                                }
                            ]
                        },
                        {
                             //tableHeader.inventoryAccountName
                            // title: '库存科目名称',
                            title: 'tableHeader.inventoryAccountName',
                            key: 'stockSubjectName',
                            type: FormTypes.input,
                            width:"300px",
                            placeholder: this.$t('tip.pleaseInput') +'${title}',
                            defaultValue: '',
                            validateRules: [
                                {
                                    required: false, // 必填
                                    message: this.$t('tip.pleaseInput') + '${title}' // 提示的文本
                                }
                            ]
                        },
                        {
                             //tableHeader.salesCostAccountCode
                            // title: '销售成本科目编号',
                            title: 'tableHeader.salesCostAccountCode',
                            key: 'saleSubjectCode',
                            type: FormTypes.select,
                            dictCode:"efs_cap_subject_item,name,code",
                            width:"300px",
                            placeholder: this.$t('tip.pleaseInput') +'${title}',
                            defaultValue: '',
                            validateRules: [
                                {
                                    required: false, // 必填
                                    message: this.$t('tip.pleaseInput') + '${title}' // 提示的文本
                                }
                            ]
                        },
                        {
                             //tableHeader.salesCostAccountName
                            title: 'tableHeader.salesCostAccountName',
                            // title: '销售成本科目名称',
                            key: 'saleSubjectName',
                            type: FormTypes.input,
                            width:"300px",
                            placeholder: this.$t('tip.pleaseInput') +'${title}',
                            defaultValue: '',
                            validateRules: [
                                {
                                    required: false, // 必填
                                    message: this.$t('tip.pleaseInput') + '${title}' // 提示的文本
                                }
                            ]
                        },
                    ]
                },
                url: {
                    add: "/costList/efsCapCost/add",
                    edit: "/costList/efsCapCost/edit",
                    queryById: "/costList/efsCapCost/queryById",
                    efsCapCostDetail: {
                        list: '/costList/efsCapCost/queryEfsCapCostDetailByMainId'
                    },
                }
            }
        },
        props: {
            //流程表单data
            formData: {
                type: Object,
                default: ()=>{},
                required: false
            },
            //表单模式：false流程表单 true普通表单
            formBpm: {
                type: Boolean,
                default: false,
                required: false
            },
            //表单禁用
            disabled: {
                type: Boolean,
                default: false,
                required: false
            }
        },
        computed: {
            formDisabled(){
                if(this.formBpm===true){
                    if(this.formData.disabled===false){
                        return false
                    }
                    return true
                }
                return this.disabled
            },
            showFlowSubmitButton(){
                if(this.formBpm===true){
                    if(this.formData.disabled===false){
                        return true
                    }
                }
                return false
            }
        },
        created () {
            //如果是流程中表单，则需要加载流程表单data
            this.showFlowData();
        },
        methods: {
            addBefore(){
                this.form.resetFields()
                this.efsCapCostDetailTable.dataSource=[]
            },
            getAllTable() {
                let values = this.tableKeys.map(key => getRefPromise(this, key))
                return Promise.all(values)
            },
            /** 调用完edit()方法之后会自动调用此方法 */
            editAfter() {
                let fieldval = pick(this.model,'companyCode','groupCode','costCode','costName','types','validFlag')
                this.$nextTick(() => {
                    this.form.setFieldsValue(fieldval)
                })
                // 加载子表数据
                if (this.model.id) {
                    let params = { id: this.model.id }
                    this.requestSubTableData(this.url.efsCapCostDetail.list, params, this.efsCapCostDetailTable)
                }
            },
            /** 整理成formData */
            classifyIntoFormData(allValues) {
                let main = Object.assign(this.model, allValues.formValue)
                return {
                    ...main, // 展开
                    efsCapCostDetailList: allValues.tablesValue[0].values,
                }
            },
            //渲染流程表单数据
            showFlowData(){
                if(this.formBpm === true){
                    let params = {id:this.formData.dataId};
                    getAction(this.url.queryById,params).then((res)=>{
                        if(res.success){
                            this.edit (res.result);
                        }
                    })
                }
            },
            validateError(msg){
                this.$message.error(msg)
            },
            popupCallback(row){
                this.form.setFieldsValue(pick(row,'companyCode','groupCode','costCode','costName','types','validFlag'))
            },
        }
    }
</script>

<style scoped>
</style>